import { useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { Pencil } from "lucide-react";
const initialData = [
  { month: "Jan", expense: 4000 },
  { month: "Feb", expense: 3000 },
  { month: "Mar", expense: 5000 },
  { month: "Apr", expense: 2780 },
  { month: "May", expense: 1890 },
  { month: "Jun", expense: 2390 },
  { month: "Jul", expense: 3490 },
];

const CustomTooltip = ({ active, payload, onEdit }) => {
  if (!active || !payload || !payload.length) return null;

  const { month, expense } = payload[0].payload;

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e2e8f0",
        borderRadius: "10px",
        padding: "12px 14px",
        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
        minWidth: "170px",
      }}
    >
      <div>
        <div
          style={{
            fontSize: "11px",
            color: "#94a3b8",
            fontWeight: 600,
            marginBottom: 2,
          }}
        >
          {month}
        </div>

        <div
          style={{
            fontSize: "15px",
            color: "#1e293b",
            fontWeight: 700,
          }}
        >
          ₹{expense.toLocaleString()}
        </div>
      </div>
    </div>
  );
};

export default function ExpenseLineChart() {
  const [chartData, setChartData] = useState(initialData);
  const [activeIndex, setActiveIndex] = useState(null);

  const handleEdit = (month, newValue) => {
    setChartData((prev) =>
      prev.map((d) => (d.month === month ? { ...d, expense: newValue } : d)),
    );
  };

  const handleChartMouseMove = (state) => {
    if (state && state.activeTooltipIndex !== undefined) {
      setActiveIndex(state.activeTooltipIndex);
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        border: "1px solid #E5E7EB",
        padding: "24px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <ResponsiveContainer width="100%" height={350}>
        <LineChart
          data={chartData}
          margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
          onMouseMove={handleChartMouseMove}
          onMouseLeave={() => setActiveIndex(null)}
        >
          <CartesianGrid
            strokeDasharray=""
            stroke="#E5E7EB"
            vertical={false}
            horizontal={false}
          />
          <XAxis
            dataKey="month"
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#6B7280", fontSize: 12, fontWeight: 500 }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#6B7280", fontSize: 12, fontWeight: 500 }}
            tickFormatter={(v) => `₹${v.toLocaleString()}`}
          />
          <Line
            type="monotone"
            dataKey="expense"
            stroke="#015c57"
            strokeWidth={3}
            dot={{
              fill: "#015c57",
              r: 6,
              strokeWidth: 2,
              stroke: "#fff",
              cursor: "pointer",
            }}
            activeDot={{ r: 8, fill: "#013d39" }}
            isAnimationActive={true}
          />

          {activeIndex !== null && (
            <foreignObject
              x={
                activeIndex >= chartData.length - 2
                  ? (activeIndex - 1.5) * (100 / chartData.length) + "%"
                  : (activeIndex + 0.5) * (100 / chartData.length) + "%"
              }
              y={20}
              width={220}
              height={150}
              style={{ overflow: "visible", pointerEvents: "auto" }}
            >
              <CustomTooltip
                active={true}
                payload={[{ payload: chartData[activeIndex] }]}
                onEdit={handleEdit}
              />
            </foreignObject>
          )}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
